import * as antdvIcons from '@ant-design/icons-vue'
import tool from './utils/tool'
import errorHandler from './utils/errorHandler'
import print from 'vue3-print-nb'
import uploadFile from '@/views/components/uploadFile/index.vue'
import { VueMasonryPlugin } from 'vue-masonry'

export default {
	install(app) {
		// 挂载全局对象
		app.config.globalProperties.$TOOL = tool
		app.component('upload', uploadFile)
		
		// 统一注册antdv图标
		for (const icon in antdvIcons) {
			app.component(icon, antdvIcons[icon])
		}
		
		// 注册打印插件
		app.use(print)

		// 注册瀑布流插件
		app.use(VueMasonryPlugin)
		
		// 全局代码错误捕捉
		app.config.errorHandler = errorHandler
	}
}
